<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Mixtura
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Mixtura</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <div class="card-body justify-content-between">
    <div class="row filtros-header">
      <div></div>
          <button type="button" mdbBtn color="info" (click)="showModalAgregar()" size="sm"
            mdbWavesEffect>Agregar</button>
    </div>
  </div>
  <!-- FOOTER -->

</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Descripción</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!MixturaList || MixturaList.length === 0">
            <td colspan="3" style="text-align: center;">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let mix of MixturaList">
            <td>{{ mix.nombre }}</td>
            <td>
              <div *ngIf="mix.activado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!mix.activado">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="EditMixtura(mix);" mdbTooltip="Editar" placement="right"><mdb-icon fas
                  icon="pen"></mdb-icon></button>
              <button *ngIf="!mix.activado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(mix)" mdbTooltip="Activar" placement="right"><mdb-icon fas
                  icon="ban"></mdb-icon></button>
              <button *ngIf="mix.activado" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(mix)" mdbTooltip="Desactivar" placement="right"><mdb-icon fas
                  icon="check"></mdb-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar y Editar mixtura -->
<app-agregar-editar-mixtura (onSuccess)="buscar(1)"></app-agregar-editar-mixtura>
<app-agregar-editar-mixtura (onSuccess)="buscar(1)"></app-agregar-editar-mixtura>
